import { REQUIRED_BLOCK } from '../../helpers/questionnaires/requiredFieldsBlock';

// De tekst die de respondent leest wanneer hij op een vraag blijft staan.
//
// Los van de poort zelf, zodat die puur blijft (en zonder vertalingen te
// toetsen is), en gedeeld door de twee schermen die hem tonen — anders staan er
// straks twee formuleringen voor dezelfde blokkade.

/**
 * @param {string} reden - Waarde uit REQUIRED_BLOCK
 * @param {Object<string, string>} [translations] - Vertaalde UI-teksten
 * @returns {string} De melding; leeg als er geen blokkade is
 */
const requiredBlockMessage = (reden, translations) => {
    if (reden === REQUIRED_BLOCK.ALLE_RIJEN) {
        return translations?.['Beantwoord alle rijen'] || 'Beantwoord alle rijen om verder te gaan';
    }
    if (reden === REQUIRED_BLOCK.CONTROLE_MISLUKT) {
        return translations?.['Controleren mislukt']
            || 'Het controleren van de vraag is niet gelukt. Probeer het opnieuw.';
    }
    if (reden === REQUIRED_BLOCK.VERPLICHT) {
        return translations?.['Vraag verplicht']
            || 'Deze vraag is verplicht. Geef een antwoord om verder te gaan.';
    }

    return '';
};

export default requiredBlockMessage;
